import {Device} from '../../constants';
import RedeemViewStyled from '../redeem/RedeemViewStyled';
import styled from 'styled-components';

export default styled(RedeemViewStyled)`
  padding: 10px 0;
  min-height: 100vh;
  .load-diamond {
    background-color: #000;
    outline: 5px solid #000;
  }
  .inviteLoading {
    @media screen and ${Device.laptop} {
      min-height: 100vh;
    }
  }
  @media screen and ${Device.laptop} {
    min-height: auto;
    padding: 0 0 50px;
  }
  @media screen and ${Device.mobileL} {
    padding: 0 0 24px;
  }
`;
